import { render, staticRenderFns } from "./transfer-modal.vue?vue&type=template&id=3df586d0&"
import script from "./transfer-modal.ts?vue&type=script&lang=js&"
export * from "./transfer-modal.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports